import {
    FETCH_COUNTRIES_START,
    FETCH_COUNTRIES_SUCCESS,
    FETCH_COUNTRIES_FAILURE,
  } from "./ActionConstant";
  
  export function fetchCountriesStart(data) {
    return {
      type: FETCH_COUNTRIES_START,
      data,
    };
  }
  
  export function fetchCountriesSuccess(data) {
    return {
      type: FETCH_COUNTRIES_SUCCESS,
      data,
    };
  }
  
  export function fetchCountriesFailure(error) {
    return {
      type: FETCH_COUNTRIES_FAILURE,
      error,
    };
  }
